/* eslint-disable */
import React from "react";
import InputMask from 'react-input-mask';
import TextField from "@mui/material/TextField";
import "../TextInput/TextInput.scss"
// localizations
const InputMaskField = (props:any) => {
  const { InputProps, sx, type, label, autoFocus, className, variant, id, name, value, onChange, mask, autoComplete, error, helperText, FormHelperTextProps, hideLabel, inputProps } = props

  return (
    <div className="w-100" id="NumberInput">
      {!hideLabel && (
        <p className="mb-0 label mb-1 familysora600 text-capitalize">{label}</p>
      )}
      <InputMask maskChar={null} mask={mask} value={value} onChange={onChange}>
        {(maskInputProps:any) => (
          <TextField
            {...maskInputProps}
            type={type}
            sx={sx}
            id={id}
            autoFocus={autoFocus}
            name={name}
            variant={variant}
            className={className}
            label={hideLabel ? undefined : label}
            InputProps={InputProps}
            inputProps={inputProps}
            autoComplete={autoComplete}
            error={error}
            helperText={helperText}
            FormHelperTextProps={FormHelperTextProps}
          />
        )}
      </InputMask>
    </div>
  )
}

export default InputMaskField;
